import { render, staticRenderFns } from "./particle.vue?vue&type=template&id=64eda23f&scoped=true&"
import script from "./particle.vue?vue&type=script&lang=js&"
export * from "./particle.vue?vue&type=script&lang=js&"
import style0 from "./particle.vue?vue&type=style&index=0&id=64eda23f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eda23f",
  null
  
)

export default component.exports